import { formatInstant } from '../../helpers/dataHelper';
import type { Edi837Claim } from './types';

/** Institutional (837I) claims carry dates in statementDate*; professional claims use serviceDate*. */
export const get837ServiceDates = (
    claim: Edi837Claim,
): { from?: string; to?: string } => {
    if (claim.serviceDateFrom || claim.serviceDateTo) {
        return { from: claim.serviceDateFrom, to: claim.serviceDateTo };
    }
    return { from: claim.statementDateFrom, to: claim.statementDateTo };
};

/**
 * Discharge date lives in statementDateTo, time-only in dischargeTime (HH:MM[:SS] or HHMM).
 * Formatted like admissionDateAndHour (formatInstant), e.g. "Mar 19, 2026, 5:45 PM" or "5:45 PM".
 */
export const format837DischargeDateTime = (claim: Edi837Claim): string | undefined => {
    const time = claim.dischargeTime?.trim();
    if (!time) return undefined;
    const hms = time.replace(/:/g, '');
    if (!/^\d{4}(\d{2})?$/.test(hms)) return time;
    const hh = Number(hms.slice(0, 2));
    const mm = Number(hms.slice(2, 4));
    if (hh > 23 || mm > 59) return time;

    const ymd = claim.statementDateTo?.replace(/-/g, '').slice(0, 8);
    if (ymd && /^\d{8}$/.test(ymd)) {
        const iso = `${ymd.slice(0, 4)}-${ymd.slice(4, 6)}-${ymd.slice(6, 8)}T${hms.slice(0, 2)}:${hms.slice(2, 4)}:00`;
        const formatted = formatInstant(iso);
        if (formatted !== '-') return formatted;
    }
    return new Date(2000, 0, 1, hh, mm).toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
    });
};
